module.exports = __webpack_public_path__ + "static/media/Review.db71039b.jpg";